var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgFaviconEh = function SvgFaviconEh(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_xA0_Image_00000061441164331287072840000005525581948453378210_",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22,
    height: 25,
    style: {
      enableBackground: "new 0 0 22 25"
    },
    xmlSpace: "preserve",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#EEB111;}\n.st1{fill:#490E67;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M29.8,0.9C25,2.1,20.5,4,16.2,6.8l0,0c-3.6,2.3-7,5.2-10.2,8.8c3.6,2,7,4.5,10.1,7.5c3.1-3,6.6-5.4,10.1-7.5 L29.8,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M2.2,0.9l3.7,14.8c3.3-3.6,6.7-6.5,10.2-8.8l0,0l0,0C11.8,3.9,7,2.1,2.2,0.9"
  }))));
};
export { SvgFaviconEh as ReactComponent };
export default __webpack_public_path__ + "static/media/favicon-eh.67b2baef.svg";